import { makeAutoObservable } from "mobx";
import { observer } from "mobx-react-lite";
import dialog from '../../../components/dialog'
import { isJDiwork } from "../../../utils"
import { v4 as uuid } from "uuid"

class DialogRender {
  DialogView = observer(({ storeProps, modalRootId }) => {
    return <>{
      storeProps.dialogStack.map((item, index) => {
        return dialog(item, index, storeProps, modalRootId)
      })
    }</>
  });

  constructor() {
    makeAutoObservable(this);
  }

  render(props) {
    const div = document.createElement('div');
    let modalRootId = 'root'
    // 工作台弹窗挂载的节点是id为serviceCode的div
    if (isJDiwork()) modalRootId = props.params?.diworkCode || props.params?.serviceCode
    // 小程序的根节点是id为container的div
    if (window.location.href.startsWith('file://')) modalRootId = 'container'

    const id = uuid()
    div.setAttribute('id', `ynf-Dialog_${modalRootId}_${id}`);
    if (document.getElementById(modalRootId)) {
      document.getElementById(modalRootId).append(div)
    } else {
      document.body?.append(div)
    }
    const ele = <this.DialogView storeProps={props} modalRootId={modalRootId} />
    ReactDOM.render(ele, document.querySelector(`#ynf-Dialog_${modalRootId}_${id}`))
  }
}
export default DialogRender